export default {"src":"/kelp/_next/static/media/kelp_app_logo.9210c0ca.svg","height":40,"width":99,"blurWidth":0,"blurHeight":0};